module.exports = __webpack_public_path__ + "img/homework-lh.65a7af1a.png";